import { UIOverlayViewStatus } from 'common-ts/dist/models/UIOverlayViewStatus';

import {
  Box, Button, createStyles, Dialog, Grid, IconButton, makeStyles, Theme, Typography, useTheme, Fade, Slide
} from '@material-ui/core';
import { ArrowBack, ArrowDownward, ArrowForward, ArrowRight, Close } from '@material-ui/icons';
import AddTaskIcon from '@mui/icons-material/AddTask';
import ChecklistRtlIcon from '@mui/icons-material/ChecklistRtl';
import Icon from '@mui/material/Icon';

import { FareastButton } from './OverlayComponentButton';
import { useAppDispatch, useAppSelector } from '../reduxhooks';
import { Order } from 'common-ts/dist/models/Orders';
import { BodyMeasurements } from 'common-ts/dist/models/UserMeasurements';
import { closeOverlayAndReset as closeOverlayAndResetEditView, openOverlay as openOverlayEditView, setValues as setValuesEditView } from '../redux/UIOverlayMeasurementEditViewRedux';
import React, { useEffect } from 'react';
import OverlayComponentButton from './OverlayComponentButton';
import { Player } from '@lottiefiles/react-lottie-player';
import { TypeAnimation } from 'react-type-animation';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backButton: {
      position: 'absolute',
      top: theme.spacing(2),
      right: theme.spacing(2),
      backgroundColor: 'black',
      borderRadius: '50%',
      padding: '5px',
    },
    backButtonIcon: {
      padding: '0',
      color: 'white',
    },
    dialogContent: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      // padding: '1em 1.5em',
      // overflowY: 'hidden',
    },
    pageTitle: {
      marginTop: '1em',
      fontSize: '1.2em',
      width: '80%',
      fontWeight: 550,
    },
    pageItem: {
      display: 'grid',
      gridTemplateColumns: '1fr 8fr',
      marginTop: '1em',
    },
    pageItemIcon: {
      marginRight: '0.2em',
    },
    pageItemTitle: {
      paddingTop: '0.2em',
      fontSize: '0.8em',
      fontWeight: 500,
    },
    pageItemDescription: {
      gridColumn: '2',
      paddingTop: '0.2em',
      paddingRight: '0.5em',
      fontSize: '0.7em',
    },
  }),
);

export function StarWarsNameCard({name, isOneName=false}: {name: string, isOneName?: boolean}) {
  return (
    <Box style={{
      width: '100%',
      position: 'relative',
      margin: '20px 0px 2px',
      minHeight: '80%',
    }}>
      <video muted autoPlay loop src={'https://studiosclo.uk/general/Profil_Personal_Fit_Card_05.mp4'}
      playsInline
        style={{
          width: '100%'
        }}
      />
      <Typography style={{
        position: 'absolute',
        top: '75%',
        left: '28%',
        fontSize: '10%',
        fontWeight: 500,
        color: '#ffffff',
      }}>
        13 April 2025
      </Typography>
      <TypeAnimation
        sequence={
          isOneName ? [
          name,
          2400, 
          'KAMU',
          2400
        ] : [
          'Louis',
          900, // Waits 1s
          name,
          2400, // Waits 1s
          'Ubay', 
          900, // Waits 1s
          'Mike',
          900,
          'KAMU',
          3400
        ]}
        wrapper="div"
        cursor={true}
        repeat={Infinity}
        style={{ 
          position: 'absolute',
          top: '54.1%',
          left: '28%',
          fontSize: '4.3vw',
          fontFamily: 'OakesGrotesk',
          fontWeight: 500,
          color: '#ffffff',
        }}
        speed={12}
      />
    </Box>
  )
}

interface Props {
  handleBack: () => void
  handleNext: (updatedCurrentFlowData: any) => void
  isDesktop?: boolean
  manualMediaWidth?: string
}

export default function PersonalSizeBenefit({ handleBack, handleNext, isDesktop=false, manualMediaWidth }: Props) {
  const classes = useStyles();

  const [cobaSekarangIndex, setCobaSekarangIndex] = React.useState(0);
  const firstName = useAppSelector(state => state.account.name?.split(' ')?.[0] ?? 'Fariz');

  const [numberCountObj, setNumberCountObj] = React.useState({
    currentCount: 250,
    targetCount: 300,
    lastAddTargetCount: 50,
    macamStr: 'MACAM KAOS'
  })

  useEffect(() => {
    const element = document.getElementById("univ-size-benefit-0");
    if (element) {
      element.scrollIntoView({behavior: "smooth", block: 'center'});
    }

    const intervalId = setInterval(() => {
      setCobaSekarangIndex(t => (t + 1) % 3);
    }, 4000);

    const intervalIdTarget = setInterval(() => {
      const randomInt = Math.round(24 + Math.random() * 17);
      const macamStr = ['MACAM POLO', 'MACAM KAOS', 'MACAM KEMEJA', 'MACAM BATIK']?.[(Math.round(10 * Math.random()) % 4)];
      setNumberCountObj(t => ({ 
        currentCount: t.currentCount,
        targetCount: t.targetCount > 500 ? randomInt : t.targetCount + randomInt,
        lastAddTargetCount: randomInt,
        macamStr: macamStr,
      }));
    }, 2800);
    const intervalIdCurrentToTarget = setInterval(() => {
      setNumberCountObj(t => ({ 
        currentCount: t.currentCount === t.targetCount ? t.currentCount : t.currentCount < t.targetCount ? t.currentCount + 1 : 1,
        targetCount: t.targetCount,
        lastAddTargetCount: t.lastAddTargetCount,
        macamStr: t.macamStr,
      }));
    }, 30);

    return () => {
      clearInterval(intervalId);
      clearInterval(intervalIdTarget);
      clearInterval(intervalIdCurrentToTarget);
    };
  }, []);

  if (isDesktop) {
    return (
      <>
      <Box  id='univ-size-benefit-0' ></Box>
      <Box style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center'
      }}>
        <Box id='univ-size-benefit-3' style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          paddingBottom: '100px',
        }} onClick={() => {
          handleNext('');
  
          // const element = document.getElementById("univ-size-benefit-4");
  
          // if (element) {
          //   element.scrollIntoView({behavior: "smooth", block: 'center'});
          // }
        }}>
          <Box style={{
            width: manualMediaWidth ? manualMediaWidth : '67%',
            overflow: 'clip',
            margin: '4% 0px 0px'
          }}>
            <Player
              key='regular-animation'
              autoplay
              loop
              src={'https://studiosclo.uk/general/Size_Card_Demonstration_2.json'}
              style={{
                width: '100%',
                marginLeft: '0%'
              }}
            >
            </Player>
          </Box>
          <Typography style={{
            fontSize: '13px',
            color: 'rgb(9, 9, 9)',
            marginTop: '2px',
            letterSpacing: '0.5px',
            border: '1px solid rgb(102, 102, 102)', 
            padding: '4px 11px 2px',
            borderRadius: '30px',
            fontWeight: 500,
          }}>
            AUTO FIT ADJUST
          </Typography>
          {/* <Typography style={{
            fontSize: '22px',
            fontWeight: 600,
            marginTop: '10px',
            textUnderlineOffset: '3px'
          }}>
            Dari Ukuran Satu Baju, <u>Disesuaikan</u><br/>Ke Baju Lainnya
          </Typography> */}
          <Typography style={{
            fontSize: '15px',
            color: 'rgb(24, 24, 24)',
            textAlign: 'center',
            margin: '12px 20px 20px',
            letterSpacing: '0.2px',
            fontWeight: 300,
            width: '80%',
          }}>
            Kami <span style={{fontWeight: 600}}>menyesuaikan otomatis</span> ukuran yang fit dengan kamu, <br/> ke semua produk lainnya.
          </Typography>
          <Box style={{
            border: '1px solid black',
            borderRadius: '40px',
            padding: '3px 6px 3px 14px',
            display: 'flex',
            justifyContent: 'space-between',
            width: '69px',
            cursor: 'pointer',
            backgroundColor: '#121212',
            color: '#fff',
          }}>
            <Typography style={{fontSize: '12px', fontWeight: 500, paddingTop: '4px', letterSpacing: '0.3px'}}>
              LANJUT 
            </Typography>
            <ArrowRight/>
          </Box>
        </Box>
      </Box>
      </>
    )
  }
  
  return (
  <>
    {/* <Box
      className={classes.backButton}
      onClick={handleBack}
    >
      <IconButton className={classes.backButtonIcon}>
        <Close fontSize='small'/>
      </IconButton>
    </Box> */}
    <Box  id='univ-size-benefit-0' ></Box>
    <Box style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center'
    }}>
      {/* <Box style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }} onClick={() => {
        const element = document.getElementById("univ-size-benefit-2");

        if (element) {
          element.scrollIntoView({behavior: "smooth", block: 'center'});
        }
      }}>
        <Typography style={{
          fontSize: '11px',
          color: 'rgb(98,98,98)',
          marginTop: '40px',
          letterSpacing: '0.5px'
        }}>
          PROFIL UKURAN PERSONAL
        </Typography>
        <Typography style={{
          fontSize: '32px',
          fontWeight: 600,
          marginTop: '10px',
        }}>
          Buat Semua Jadi Pas
        </Typography>
        <Typography style={{
          fontSize: '10.2px',
          color: 'rgb(114, 114, 114)',
          textAlign: 'center',
          margin: '7px 20px',
          letterSpacing: '0.2px',
          fontWeight: 300,
        }}>
          Dengan Ukuran Personal Kamu, semua produk yang kamu beli akan<br/>datang dengan ukuran pas dan sesuai dengan yang kamu mau.
        </Typography>
        <StarWarsNameCard name={firstName}/>
        <Box style={{
          border: '1px solid black',
          borderRadius: '40px',
          padding: '6px 16px',
          display: 'flex',
          justifyContent: 'space-between',
          width: '180px',
        }}>
          <Typography style={{fontSize: '12px', fontWeight: 500, paddingTop: '4px', letterSpacing: '0.3px'}}>
            LIHAT HASIL KAMU
          </Typography>
          <ArrowDownward/>
        </Box>
      </Box> */}
      {/* <Box id='univ-size-benefit-2' style={{ // Drop Shadow Box
        width: '100%',
        position: 'relative',
        boxShadow: '0px 0px 17px 7px #eeeeee',
        margin: '30px 0px',
        padding: '0px 0px 8px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }} onClick={() => {
        const element = document.getElementById("univ-size-benefit-3");

        if (element) {
          element.scrollIntoView({behavior: "smooth", block: 'center'});
        }
      }}>
        <video muted autoPlay loop src={'https://studiosclo.uk/general/Carousel10_ProfilPersonalFit.mp4'}
        playsInline
          style={{
            width: '100%',
            marginTop: '0px'
          }}
        />
        <Typography style={{
          fontSize: '11px',
          color: 'rgb(98,98,98)',
          marginTop: '11px',
          letterSpacing: '0.5px'
        }}>
          MAIN BENEFIT
        </Typography>
        <Typography style={{
          fontSize: '25px',
          fontWeight: 600,
          marginTop: '5px',
        }}>
          Pasti Pas Buat<br/>{numberCountObj.currentCount} Produk
        </Typography>
        <Slide in={numberCountObj.currentCount !== numberCountObj.targetCount} direction={"up"} timeout={{
          enter: 500,
          exit: 10000
        }}>
          <div>
            <Fade in={numberCountObj.currentCount !== numberCountObj.targetCount} timeout={{
              enter: 300,
              exit: 1000
            }}>
              <Typography style={{
                paddingRight: '90px',
                color: 'rgb(20, 120, 20)',
                fontWeight: 500,
                fontSize: '12px',
                marginBottom: '24px', //'12px',
                textAlign: 'center',
                lineHeight: '14px'
              }}>
                + {numberCountObj.lastAddTargetCount}<br/>
                <span style={{fontSize: '7.5px', paddingLeft: '7px', letterSpacing: '0.3px', fontWeight: 600}}>{numberCountObj.macamStr}</span>
              </Typography> 
            </Fade>
          </div>
        </Slide>
        <Box style={{
          border: '1px solid black',
          borderRadius: '40px',
          padding: '6px 16px',
          margin: '-4px 0px 14px',
          display: 'flex',
          justifyContent: 'space-between',
          width: '84px',
        }}>
          <Typography style={{fontSize: '12px', fontWeight: 500, paddingTop: '4px', letterSpacing: '0.3px'}}>
            LANJUT 
          </Typography>
          <ArrowDownward/>
        </Box>
      </Box> */}
      <Box id='univ-size-benefit-3' style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }} onClick={() => {
        handleNext('');

        // const element = document.getElementById("univ-size-benefit-4");

        // if (element) {
        //   element.scrollIntoView({behavior: "smooth", block: 'center'});
        // }
      }}>
        <Box style={{
          width: '100%',
          overflow: 'clip',
          margin: '18% 0px 0px'
        }}>
          <Player
            key='regular-animation'
            autoplay
            loop
            src={'https://studiosclo.uk/general/Size_Card_Demonstration_2.json'}
            style={{
              width: '100%',
              marginLeft: '0%'
            }}
          >
          </Player>
        </Box>
        <Typography style={{
          fontSize: '11px',
          color: 'rgb(98,98,98)',
          marginTop: '40px',
          letterSpacing: '0.5px'
        }}>
          Membuat Profil Ukuran Kamu
        </Typography>
        <Typography style={{
          fontSize: '22px',
          fontWeight: 600,
          marginTop: '10px',
          textUnderlineOffset: '3px'
        }}>
          Dari Ukuran Satu Baju, <u>Disesuaikan</u><br/>Ke Baju Lainnya
        </Typography>
        <Typography style={{
          fontSize: '10.2px',
          color: 'rgb(114, 114, 114)',
          textAlign: 'center',
          margin: '7px 20px 13%',
          letterSpacing: '0.2px',
          fontWeight: 300,
        }}>
          Mulai dari ukuran yang paling pas buat kamu, kami menyesuaikan baju kategori lainnya sehingga sama fit dengan ukuran kamu sebelumnya.
        </Typography>
        <Box style={{
          border: '1px solid black',
          borderRadius: '40px',
          padding: '6px 16px',
          display: 'flex',
          justifyContent: 'space-between',
          width: '84px',
        }}>
          <Typography style={{fontSize: '12px', fontWeight: 500, paddingTop: '4px', letterSpacing: '0.3px'}}>
            LANJUT 
          </Typography>
          <ArrowRight/>
        </Box>
      </Box>
      {/* <Box id='univ-size-benefit-4' style={{
        width: '100%',
        margin: '30px 0px -1px',
        position: 'relative',
        backgroundColor: '#000000'
      }}
      onClick={() => {
        handleNext('');
      }}>
        <img alt={'coba-skr-header'} src={'https://studiosclo.uk/general/Coba_Sekarang_Footer_1.png'}
          style={{
            width: '100%',
            position: 'relative',
            zIndex: 1,
          }}
        />
        <Box style={{
          position: 'relative',
          zIndex: 0,
          aspectRatio: '1080/1220',
          marginTop: '-15%',
        }}
        >
          {
            [
              'https://studiosclo.uk/general/Coba_Sekarang_1.jpg',
              'https://studiosclo.uk/general/Coba_Sekarang_2.jpg',
              'https://studiosclo.uk/general/Coba_Sekarang_3.jpg',
            ].map((carouselItemData, i) => {
              return (
                <Fade in={cobaSekarangIndex === i} timeout={1500}>
                  <img alt='sdfsdf' 
                  src={carouselItemData} 
                  style={{
                    position: 'absolute',
                    top: '0px',
                    left: '0px',
                    width: '100%'
                  }}/>
                </Fade>
              );
            })
          }
        </Box> */}
        {/* <img alt={'click-button-coba'}
        src={'https://studiosclo.uk/general/buat_ukuran_button.png'}
        style={{
          position: 'absolute',
          bottom: '4%',
          right: '5%',
          width: '30%'
        }}
        /> */}
        {/*<Box style={{
          position: 'absolute',
          bottom: '5%',
          right: '6%',
          border: '1px solid black',
          borderRadius: '40px',
          padding: '6px 16px',
          display: 'flex',
          justifyContent: 'space-between',
          width: '170px',
          backgroundColor: '#ffffff'
        }}>
          <Typography style={{fontSize: '12px', fontWeight: 500, paddingTop: '4px', letterSpacing: '0.3px'}}>
            LIHAT HASIL KAMU
          </Typography>
          <ArrowForward/>
        </Box>
      </Box> */}
    </Box>
  </>);
}